const ScriptLoader = (url: string, position?: 'body' | 'head') => {
  const promise = new Promise((resolve, reject) => {
    if (url) {
      const scriptElement = document.createElement('script');
      scriptElement.setAttribute('src', url);
      scriptElement.setAttribute('type', 'text/javascript');
      if (position === 'head') document.head.appendChild(scriptElement);
      else document.body.appendChild(scriptElement);
      scriptElement.onload = () => {
        resolve(true);
      };
    } else reject(new Error('Error'));
  });
  return promise;
};
export default ScriptLoader;
